import { render, staticRenderFns } from "./Blocked.vue?vue&type=template&id=44870034&"
import script from "./Blocked.vue?vue&type=script&lang=js&"
export * from "./Blocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports